import React from 'react';
import { Grid, TextField, Typography, Divider, Button, Box } from '@mui/material';
import { FormikProps } from 'formik';
import { ClientFormValues } from '../../../types/client';

interface Props {
  formik: FormikProps<ClientFormValues>;
  showCopyButton?: boolean;
}

const TradingAddressSection: React.FC<Props> = ({ formik, showCopyButton = true }) => {
  // Debug business type
  console.log('TradingAddressSection - businessType:', formik.values.businessType);
  console.log('Is Sole Trader?', formik.values.businessType === 'Sole Trader');
  console.log('Home Address available?', Boolean(formik.values.homeAddressLine1));
  console.log('Registered Address available?', Boolean(formik.values.registeredAddressLine1));

  // Function to copy address to trading address
  const copyAddressToTrading = () => {
    // For Limited Companies and Charities, copy from Registered Business Address
    if (formik.values.businessType !== 'Sole Trader' && formik.values.registeredAddressLine1) {
      formik.setFieldValue('tradingAddressLine1', formik.values.registeredAddressLine1);
      formik.setFieldValue('tradingAddressLine2', formik.values.registeredAddressLine2 || '');
      formik.setFieldValue('tradingCity', formik.values.registeredCity || '');
      formik.setFieldValue('tradingCounty', formik.values.registeredCounty || '');
      formik.setFieldValue('tradingPostcode', formik.values.registeredPostcode || '');
    }
    // For Sole Traders, copy from Home Address
    else if (formik.values.businessType === 'Sole Trader' && formik.values.homeAddressLine1) {
      formik.setFieldValue('tradingAddressLine1', formik.values.homeAddressLine1);
      formik.setFieldValue('tradingAddressLine2', formik.values.homeAddressLine2 || '');
      formik.setFieldValue('tradingCity', formik.values.homeCity || '');
      formik.setFieldValue('tradingCounty', formik.values.homeCounty || '');
      formik.setFieldValue('tradingPostcode', formik.values.homePostcode || '');
    }
  };
  
  return (
  <>
    <Grid item xs={12}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Trading Address</Typography>
        {showCopyButton && (
          <Button 
            variant="outlined" 
            size="small" 
            onClick={copyAddressToTrading}
            sx={{ mt: 2, mb: 1 }}
          >
            {formik.values.businessType === 'Sole Trader' 
              ? 'Copy from Home Address' 
              : 'Copy from Registered Address'}
          </Button>
        )}
      </Box>
      <Divider sx={{ mb: 2 }} />
    </Grid>

    <Grid item xs={12}>
      <TextField
        fullWidth
        id="tradingAddressLine1"
        name="tradingAddressLine1"
        label="Address Line 1"
        value={formik.values.tradingAddressLine1}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.tradingAddressLine1 && Boolean(formik.errors.tradingAddressLine1)}
        helperText={formik.touched.tradingAddressLine1 && formik.errors.tradingAddressLine1}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        fullWidth
        id="tradingAddressLine2"
        name="tradingAddressLine2"
        label="Address Line 2 (Optional)"
        value={formik.values.tradingAddressLine2 || ''}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        id="tradingCity"
        name="tradingCity"
        label="City/Town"
        value={formik.values.tradingCity}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.tradingCity && Boolean(formik.errors.tradingCity)}
        helperText={formik.touched.tradingCity && formik.errors.tradingCity}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        id="tradingCounty"
        name="tradingCounty"
        label="County (Optional)"
        value={formik.values.tradingCounty || ''}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        id="tradingPostcode"
        name="tradingPostcode"
        label="Postcode"
        value={formik.values.tradingPostcode}
        onChange={(e) => formik.setFieldValue('tradingPostcode', e.target.value.toUpperCase())}
        onBlur={formik.handleBlur}
        error={formik.touched.tradingPostcode && Boolean(formik.errors.tradingPostcode)}
        helperText={formik.touched.tradingPostcode && formik.errors.tradingPostcode}
      />
    </Grid>
  </>
  );
};

export default TradingAddressSection;
